/* eslint-disable */
import React from 'react';
import { Route, } from 'react-router';

// Routes
import PaymentWrap from './_wrap/index.js';
import BraintreePaypalConfirm from 'ggApp/modules/braintree/containers/paypalConfirm';

const routes = (
  <Route
    path="payment">
    <Route component={PaymentWrap}>
      <Route
        path="paypalConfirm"
        components={BraintreePaypalConfirm}
      />
    </Route>
  </Route>
);

export default routes;
